export default function Eyebrow({ children, className = "" }) {
  return (
    <div className={`eyebrow flex items-center gap-3 ${className}`}>
      <span
        aria-hidden
        className="inline-block h-px w-8"
        style={{ background: "rgba(198,168,106,0.65)" }}
      />
      <span>{children}</span>
    </div>
  );
}
